import { Component, OnInit, EventEmitter, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, RouterOutlet } from '@angular/router';

// store
import { Observable } from 'rxjs';

import { AppState } from './app-reducer';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';
// services
import { QueuesService } from './services/queues.service';
import { ComposableService } from './services/composable.service';
import { NavigationService } from './services/navigation.service';

// util
import { find, findIndex } from 'lodash';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationTimeoutComponent, SessionStatus } from './components/confirmation-timeout.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit {
  agentName: string;
  SALESHUB_LOGOUT_URL: string;
  hideDetails: boolean;
  sub: any;
  completed: number;
  sections: any;
  currentSection: any;
  path: any;
  year: string;
  appState$: Observable<any>;
  animationState: number;
  menuData: any;
  menuItems: any;
  menuOpen: boolean = false;
  questions: any;

  timeout: number = 19 * 60;
  timeLeft: number = 19 * 60;
  timeWarning: number = 3 * 60;
  sessionIMGUrl: string = "/assets/images/1x1.png?";
  interval;
  waitingForTimeoutConfirm: boolean = false;
  miniPortal='express/financial-professional';
  // sets initial value to prevent component from being started prior to value getting updated in OnInit, below
  isNotAppPage: boolean = ['/express', '/express/welcome', '/express/financial-professional', '/express/demo-welcome', '/express/find-application', '/express/thank-you', '/express/processing', '/express/decision-details', '/express/error-blank-application', '/express/error-page', '/express/error-session', '/express/error'].includes(window.location.pathname);
  isWideScreen: boolean = false;

  validBrowser: boolean;
  private countDown: EventEmitter<number> = new EventEmitter();
  private sessionStatusEmitter: EventEmitter<SessionStatus> = new EventEmitter();
  private sessionStatus: SessionStatus;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private queuesService: QueuesService,
    private navigationService: NavigationService,
    private dialog: MatDialog,
    private composableService: ComposableService
  ) {
    this.appState$ = store.select('sections');
    this.currentSection = {};
  }

  ngOnInit() {

    // initial services
    //trigger build comment
    this.queuesService.start();
    this.composableService.bootstrap();

    // check for IE version
    this.validBrowser = true;
    this.detectIE();

    // all routes
    const routes = this.router.config;

    // grab all routes that have data prop = part of the progress bar %
    const progressRoutes = routes.filter(route => route.hasOwnProperty('data') && route.data.hasOwnProperty('isProgressRoute'));
    let expired: boolean = false;

    // router state
    this.sub = this.router.events.subscribe(event => {

      if (event instanceof NavigationStart) {

        const currentRoute = routes.filter(route => route.path == this.router.url.replace(/\?.*$/, ''));
        const disableTimer = currentRoute.filter(route => route.hasOwnProperty('data') && route.data.hasOwnProperty('disableTimer')).length > 0;
        if (disableTimer) {
          this.pauseTimer();
        } else {
          this.appState$.pipe(first())
            .subscribe((state) => {
              expired = state.expired;
              if (!expired) {
                this.restartTimer();
              }
            });
        }

      }
      if (event instanceof NavigationEnd) {

        // get current url path
        const currentUrlPath = this.route.snapshot.firstChild.routeConfig.path;

        // current section
        this.currentSection = find(progressRoutes, { path: currentUrlPath });

        // hide/show details
        this.hideDetails = this.currentSection ? false : true;
        const totalRoutes = progressRoutes.length;
        const currentSectionIndex = findIndex(progressRoutes, { path: currentUrlPath }) + 1;

        // % of progress
        this.completed = (currentSectionIndex / totalRoutes * 100);

        // toggles class that left-aligns form, but not welcome, miniportal, demo-welcome, processing or thank you pages
        this.isNotAppPage = ['express', 'express/welcome', this.miniPortal, 'express/demo-welcome', 'express/find-application', 'express/demo-modal', 'express/thank-you', 'express/processing', 'express/decision-details', 'express/error-blank-application', 'express/error-page', 'express/error-session', 'express/error'].includes(currentUrlPath);
        this.isWideScreen = [this.miniPortal].includes(currentUrlPath);
      }

    }); // /sub

    // subscribe to store
    this.appState$.subscribe((state: any) => {
      const { path, questions } = state;

      if (path) {
        this.path = path.map(item => item.url);
      }

      // update routes with "BlockCategory" prop
      if (questions) {

        const newRoutes = routes.map(item => {

          const { data } = item;
          if (data && data.blockHeading && data.blockName && data.blockName !== 'intake' && data.hasOwnProperty('isProgressRoute')) {
            const questionBlocks = find(questions, { Name: data.blockName });
            item.data.blockCategory = questionBlocks.BlockCategory || null;
            item.data.blockHeading = questionBlocks.DisplayName || null;
          }
          return item;
        });

        // update route config
        this.router.resetConfig(newRoutes);

        this.menuData = state.content.menuData;

      }
    });    

    // this year
    this.year = new Date().getFullYear().toString();

    // get agent name
    this.agentName = window['jhConfig'].firstname + ' ' + window['jhConfig'].lastname;

    // get logout url
    this.SALESHUB_LOGOUT_URL = window['jhConfig'].SALESHUB_LOGOUT_URL;

    this.navigationService.getHideMenu().subscribe(value => {
      if (value) {
        this.toggleMenu(!value);
      }
    });

    this.navigationService.getHideMenu().subscribe(value => {
      if (value) {
        this.toggleMenu(!value);
      }
    });

  } // end onInit

  public getRouterOutletState(outlet: RouterOutlet) {
    return outlet.isActivated ? outlet.activatedRoute : '';
  }

  updateTimeoutConfirm() {

    if (this.countDown && this.countDown.observers) {
      this.countDown.emit(this.timeLeft);
    }
    if (this.sessionStatusEmitter && this.sessionStatusEmitter.observers){
      this.sessionStatusEmitter.emit(this.sessionStatus);
    }
  }

  startTimer() {

    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
        this.sessionStatus = (this.timeLeft <= 0 ? SessionStatus.EXPIRED : this.timeLeft <= this.timeWarning ? SessionStatus.WARNING : SessionStatus.ACTIVE);
        this.updateTimeoutConfirm();
        if (this.sessionStatus == SessionStatus.EXPIRED) {
          this.composableService.sessionExpired();
        }
      }
      if (this.timeLeft <= this.timeWarning && this.timeLeft > 0) {
        this.confirmTimeout();
      }
    }, 1000);
  }

  pauseTimer() {
    clearInterval(this.interval);
    this.timeLeft = this.timeout;
  }

  restartTimer() {
    clearInterval(this.interval);
    this.timeLeft = this.timeout;
    this.startTimer();
  }

  confirmTimeout() {
    if (this.waitingForTimeoutConfirm || this.timeLeft > this.timeWarning){
      return;
    }
      

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.panelClass = 'timeout-panel';
    dialogConfig.id = 'timeout-panel';

    const dialogRef = this.dialog.open(ConfirmationTimeoutComponent, dialogConfig);
    dialogRef.componentInstance.sessionStatus = this.sessionStatusEmitter;
    dialogRef.componentInstance.countDown = this.countDown;
    dialogRef.componentInstance.roleIs = window['jhConfig'].Role;
    this.waitingForTimeoutConfirm = true;

    dialogRef.componentInstance.activateSession.subscribe(result => {
      if (result) {
        this.sessionIMGUrl = this.sessionIMGUrl.replace(/\?.*$/, '?' + Math.random());
        this.waitingForTimeoutConfirm = false;
        this.restartTimer();
      }
    });
    dialogRef.componentInstance.goBackToPortal.subscribe(result => {
      if (result) {
        this.pauseTimer();
        this.waitingForTimeoutConfirm = false;
        this.exitApplication(result);
      }
    });

  }

  exitApplication(goBack: boolean) {
    if (goBack) {
      // console.log('Role', window['jhConfig'].Role ?? '');
      if (window['jhConfig'].Role && window['jhConfig'].Role === 'Agent') {
        this.router.navigateByUrl(this.miniPortal);
      } else {
        this.router.navigateByUrl('express/find-application');
      }
    }
  }

  detectIE() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    const ua = window.navigator.userAgent;
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      const rv = ua.indexOf('rv:');
      const IEVersion = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      if (IEVersion <= 11) {
        this.validBrowser = false;
      }
    }
  }

  toggleMenu(bool?: boolean) {
    if (bool) {
      this.menuOpen = bool;
    } else {
      this.menuOpen = !this.menuOpen;
    }
  }

}
